export default function MergeChatLogo({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="22" y="22" width="156" height="156" rx="24" fill="#1E2433" stroke="#2A3345" strokeWidth="1.5"/>
      <rect x="32" y="32" width="68" height="62" rx="12" fill="#FF6347" opacity="0.9"/>
      <rect x="100" y="32" width="68" height="62" rx="12" fill="#00D9A6" opacity="0.9"/>
      <rect x="32" y="98" width="68" height="62" rx="12" fill="#5B8DEF" opacity="0.9"/>
      <rect x="100" y="98" width="68" height="62" rx="12" fill="#FFB347" opacity="0.9"/>
      <circle cx="100" cy="100" r="10" fill="#0C0F14" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
      <circle cx="100" cy="100" r="4" fill="white" opacity="0.9"/>
    </svg>
  );
}
